// extracted by mini-css-extract-plugin
export default {"noPhase":"PhaseIcon-module__noPhase___N_m05"};